module.exports = __webpack_public_path__ + "static/img/jiangsufenghuangchubanse.cdb9f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/jiangsufenghuangchubanse.png
// module id = xbBP
// module chunks = 46